export const quizElement =  {
    STEP: "step",
    DAY: "day",
    LANGUAGE_CODE: "languageCode",
    TEXT: "text",
    SEQUENCE: "sequence",
    SPEAKER_NAME: "speakerName",
    LEFT_WORD:"leftWord",
    RIGHT_WORD:"rightWord",
    WRITING_CONTENT:"writingContent",
    DESCRIPTION:"description",
    WORD:"word",
    VOICE_TYPE:"voiceType",
    MULTI_TRANSLATES:"multiTranslates",
}
export const WritingType=  {
    WORD:"WORD",
    DESCRIPTION:"DESCRIPTION",
}

export const langTypes = ["KO", "EN", "JA", "ZH"];
export const multiLangType = ["TH", "VN", "MN", "ID", "RU", "TW"];
export const OddDayParts =  {
    Listening:"Listening",
    Listening1:"Listening-1",
    Listening2:"Listening-2",
    Listening3:"Listening-3",
    Sentence:"Sentence",
    Hearing:"Hearing",
}
export const EvenDayParts =  {
    Dialogue:"Dialogue",
    Writing1:"Writing-1",
    Writing2:"Writing-2",
    Speaking:"Speaking",
}
export const WritingQuizSide =  {
    LEFT:'Left',
    RIGHT:'Right',
}

export const UploadType = {
    ALL:"ALL",
    PART:"PART"
}

export const StepOneUpload =  {
    languageCode: "languageCode",
    listeningContentId: "listeningContentId",
    mainText: "mainText",
    topSplitText: "topSplitText",
    bottomSplitText: "bottomSplitText",
    image: "image",
    imageDescription: "imageDescription",
    originalFileName: "originalFileName",
    extension: "extension",
    generateType: "generateType"
}
